import { useState } from 'react';
import { db } from '../db/indexedDb';
import { PlaylistCard } from '../components/PlaylistCard';
import { usePlaylists } from '../hooks/useIndexedDb';
import { useToast } from '../hooks/useToast';

export function PlaylistsPage() {
  const playlists = usePlaylists() ?? [];
  const { pushToast } = useToast();
  const [name, setName] = useState('');

  const createPlaylist = async () => {
    const trimmed = name.trim();
    if (!trimmed) return;
    await db.createPlaylist(trimmed);
    setName('');
    pushToast({ title: 'Playlist created', description: `${trimmed} is ready for tracks.` });
  };

  return (
    <section className="space-y-6">
      <div className="panel rounded-[2rem] p-6">
        <p className="text-xs uppercase tracking-[0.3em] text-accent">Create playlist</p>
        <div className="mt-4 flex flex-col gap-3 sm:flex-row">
          <input
            value={name}
            onChange={(event) => setName(event.target.value)}
            placeholder="Road trip mix"
            className="flex-1 rounded-2xl border border-white/10 bg-white/5 px-4 py-3"
          />
          <button type="button" onClick={() => void createPlaylist()} className="rounded-2xl bg-accent px-5 py-3 font-semibold text-black">
            Create
          </button>
        </div>
      </div>

      <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
        {playlists.length ? (
          playlists.map((playlist) => (
            <PlaylistCard
              key={playlist.id}
              playlist={playlist}
              trackCount={playlist.trackIds.length}
              onRename={() => {
                const nextName = window.prompt('Rename playlist', playlist.name);
                if (nextName?.trim()) {
                  void db.renamePlaylist(playlist.id, nextName.trim());
                }
              }}
              onDelete={() => {
                if (window.confirm(`Delete ${playlist.name}?`)) {
                  void db.deletePlaylist(playlist.id);
                }
              }}
            />
          ))
        ) : (
          <div className="panel rounded-[2rem] p-8 text-sm text-foreground/70">
            No playlists yet. Create one here, then add tracks from the Songs view.
          </div>
        )}
      </div>
    </section>
  );
}
